// extracted by mini-css-extract-plugin
export default {"fingerprintTable":"ClientCertificateFingerprintEntries_fingerprintTable__7dyAr"};